import { selectedProjectAtom } from '@js/store/appAtoms';
import { startPageAtom } from '@js/store/settingsAtoms';
import { PagePath } from '@routing/appUrls';
import { useAtomValue } from '@store';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const useStartPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const selectedProject = useAtomValue(selectedProjectAtom);
    const startPage = useAtomValue(startPageAtom);
    const startPageOrSelectProject = selectedProject
        ? startPage
        : 'SELECT_PROJECT_PAGE';

    const pages = [
        {
            value: 'SELECT_PROJECT_PAGE',
            label: t('startPage.selectProjectPage', { ns: 'settings' }) || '',
            navigate: () => {
                navigate(PagePath.selectProject);
            },
        },
        {
            value: 'PROJECT_PAGE',
            label: t('startPage.projectPage', { ns: 'settings' }) || '',
            navigate: () => {
                navigate(PagePath.projectPage);
            },
        },
    ];

    return {
        startPage: pages.find(
            (page) => page.value === startPageOrSelectProject,
        ),
        pages,
    };
};

export default useStartPage;
